<template>
    <div id="app">
        <router-view></router-view>
    </div>


</template>

<script>
    import {firebasePath} from "./mixins/mixins";

    export default {
        props: {

        },
        methods:{

        },
        data: () => ({

        }),
        mounted() {

        }
    }
</script>
<style>



</style>